import {Injectable} from '@angular/core';
import {HttpService} from '../../common/api/http.service';
import {Observable} from 'rxjs';
import {OutputReportSource} from '@core/interfaces/engin/reporting';
import {ReportRequest} from '@core/interfaces/engin/reporting';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {DownloadURL} from '@core/interfaces/engin/load-forecast/load-forecast';
import {APIResponse} from '@core/interfaces/system/system-common';

@Injectable()
export class ReportingApi {
    private readonly prefix = 'reporting/data-extract';
    private readonly PREFIX = 'reporting';

    constructor(private api: HttpService) {}

    getOutputReportGeneric(reportRequest: ReportRequest): Observable<OutputReportSource> {
        return this.api.post(`${this.prefix}/generic`, reportRequest);
    }

    getOutputReportAnalyzer(studyId: number, filters: string[]): Observable<OutputReportSource> {
        let params = filters.length > 0 ? '?' + filters.map((o) => 'assetClass=' + o).join('&') : '';
        return this.api.get(`${this.prefix}/analyzer-filter/${studyId}${params}`);
    }

    /*    public initSettingsByWorkflowItem(workflowItemId: number): Observable<LoadForecastSettings> {
        return this.api.get(`${this.PREFIX_SETTINGS}/${workflowItemId}`);
    }*/

    public getDataExtractPreview(
        workflowItemId: number,
        outputCategory: string,
        outputType: string,
        outputResult: string,
    ): Observable<DataSource> {
        let params = `outputCategory=${outputCategory}&outputType=${outputType}&outputResult=${outputResult}`;
        return this.api.getServerDataSource(`${this.PREFIX}/data-extract/${workflowItemId}?${params}`);
    }

    public getDataExtractCsv(
        workflowItemId: number,
        outputCategory: string,
        outputType: string,
        outputResult: string,
    ): Observable<APIResponse<DownloadURL>> {
        let params = `outputCategory=${outputCategory}&outputType=${outputType}&outputResult=${outputResult}`;
        return this.api.get(`${this.PREFIX}/data-extract/${workflowItemId}/csv?${params}`);
    }
}
